<template>
  <div :class="$style.container">
    <div :class="$style.bobber"></div>
  </div>
</template>

<script>
export default {
  name: 'BaseLoader',
};
</script>

<style lang="sass" module>
  .container
    +size(100%, 10px)
    position: relative
    border-radius: 5px
    background-color: rgba(33, 33, 33, 0.1)
    overflow: hidden

  .bobber
    +size(100px, 100%)
    position: absolute
    left: -100%
    border-radius: 5px
    background-color: rgba(33, 33, 33, 0.5)
    animation: loading 1.5s linear infinite

  @keyframes loading
    0%
      left: -100%
    100%
      left: 100%
</style>
